export default "__VITE_ASSET__DGlv6ME5__"